const PlusIcon = () => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobBoard1920Copy2" transform="translate(-559, -747)" stroke="#141718" strokeWidth="2">
                    <g id="Group4Copy4" transform="translate(567, 755) rotate(-315) translate(-567, -755)translate(563, 751)">
                        <line x1="0" y1="8" x2="8" y2="2.27373675e-13" id="Stroke1"></line>
                        <line x1="8" y1="8" x2="0" y2="2.27373675e-13" id="Stroke3"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default PlusIcon;
